import type { Site } from '@hotjar/site';
import { queryClient } from '@hotjar/webapp/utils/react-query';
import { USER_RESOURCES_QUERY_KEY } from '@hotjar/user-resources';
import type { UserResources as UserResourcesModel } from '@hotjar/user-resources';
import type { Store } from '../../../store/list/types';
import { getSiteId } from '../../../utils/getParamsFromUrlPathname';

export const getSite = (store: Store): Site => {
  const { setSite } = store.getState();

  const siteId = getSiteId();
  const userResources = queryClient.getQueryData(USER_RESOURCES_QUERY_KEY) as UserResourcesModel;

  const site = userResources.sites.find(
    (site) => site.id === parseInt(siteId as string, 10),
  ) as Site;

  setSite(site);

  return site;
};
